import React from 'react';
import { inject, observer } from 'mobx-react';
import H5CountDown from './h5';
import PCCountDown from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface CountDownProps {
    app?: AppStore;
    variant?: 'pc' | 'h5';
    site?: SiteStore;
    user?: UserAction;
    number?: number; // 结束时间戳
    showDays?: boolean; // 是否显示天数
    timeSeparator?: string; // 时分秒分隔符，不传时显示中文单位
    isShow?: boolean; // 是否显示"剩余时间:"文字
    endText?: string; // 结束后的文字
    start?: boolean; // 是否显示"后开始"
    boxStylesData?: any // 最外层父级盒子自定义样式
    itemStylesData?: any    // 单个item的自定义样式
    endTextStylesData?: React.CSSProperties; // 结束文案的自定义行内样式
    onEnd?: () => void; // 倒计时结束回调
}
type CountDownAllProps = CountDownProps & RouteComponentProps;
interface CountDownState {
    
}
@inject('app', 'site', 'user', 'topic')
@observer
class CountDown extends React.Component<CountDownAllProps, CountDownState> {
    constructor(props) {
        super(props);

    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑

    }

    componentDidUpdate(prevProps) {
       
    }
    

    render() {
        const { site, app, variant, ...props } = this.props;
        const platform = variant || app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCCountDown
                {...props}
             />;
        } else {
            return <H5CountDown
            {...props}
        />;
        }
    }
}

export default withRouter(CountDown);
